export const EMPTY_STORE_ADDRESS = {
    streetLine: "",
    city: "",
    region: "",
    country: ""
};

export const EMPTY_SHOP = {
    id: null,
    name: "",
    streetLine: "",
    city: "",
    region: "",
    country: "",
    mapsUrl: "",
    email: "",
    phones: [],
    active: true,
    openingHours: null
};

export function formatAddressSummary(address) {
    if (!address) {
        return "";
    }
    if (address.summary) {
        return address.summary;
    }
    const parts = [address.streetLine, address.city, address.region, address.country].filter(Boolean);
    return parts.join(", ");
}

export function formatShopOptionLabel(shop) {
    if (!shop) {
        return "";
    }
    const summary = shop.summary || formatAddressSummary(shop);
    return shop.name ? `${shop.name} — ${summary}` : summary;
}

export function formatHeaderShopAddress(shop) {
    if (!shop) {
        return "";
    }
    const parts = [shop.streetLine, shop.city, shop.region].filter(Boolean);
    return parts.join(", ");
}

export function getActiveShops(shops = []) {
    return shops.filter((shop) => shop.active !== false);
}

export function shopMapsUrl(shop) {
    const mapsUrl = shop?.mapsUrl?.trim();
    if (mapsUrl) {
        return mapsUrl;
    }
    const summary = shop?.summary || formatAddressSummary(shop);
    if (!summary) {
        return null;
    }
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(summary)}`;
}
